import Vue from 'vue'
import App from './App'
import router from './router'
import { VTooltip } from 'v-tooltip'
import BootstrapVue from 'bootstrap-vue'
import store from './store'
import i18n from './languages/index.js'
import VueResource from 'vue-resource'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import VueYandexMetrika from 'vue-yandex-metrika'
import 'swiper/dist/css/swiper.css'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import messagePlugin from './plugins/message.plugin'
import './filters'

Vue.use(VueAwesomeSwiper)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(messagePlugin)
Vue.directive('tooltip', VTooltip)

// Vue.use(VueYandexMetrika, {
//   id: 64572457,
//   env: process.env.NODE_ENV,
//   router,
//   options: {
//     clickmap: true,
//     trackLinks: true,
//     accurateTrackBounce: true,
//     webvisor: true,
//     trackHash: true
//   }
// })

Vue.config.productionTip = false

Vue.http.interceptors.push(function () {
  return function (response) {
    if (response.status === 401) {
      this.$router.options.logOut()
    }
  }
})

if (process.env.SENTRY_API_KEY && process.env.NODE_ENV === 'production') {
  Vue.prototype.$raven = Raven.config(process.env.SENTRY_API_KEY, {
    release: process.env.APP_VERSION || '1.0.0',
    tags: {
      git_commit_name: process.env.LAST_GIT_COMMIT_NAME
    }
  })
    .addPlugin(RavenVue, Vue)
    .install()
} else {
  Vue.prototype.$raven = {
    captureException: function (error) {
      console.log(error)
    }
  }
}

/**
 * Единственный service worker кабинета на области /.
 * Проксирует Stripo и подключает вебпуш Leadhit.
 */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', { scope: '/' })
    .then(function (reg) {
      console.log('[SW] registered, scope:', reg.scope)
    })
    .catch(function (err) {
      console.error('[SW] registration failed:', err)
    })
}

const config = {
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
}

const app = new Vue(config)

export default app



// WEBPACK FOOTER //
// ./src/main.js